import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FiX } from "react-icons/fi";
import SidebarContent from "./SidebarContent";
import "../../styles/sidebar.css";
import Logo from "../../images/light_- horizontal.png";

const Sidebar = ({ type, isOpen, onNavigate }) => (
  <aside className={`vertical-menu ${isOpen ? "is-open" : ""}`}>
    <div className="sidebar-brand">
      <Link to="/" className="sidebar-brand__link" onClick={onNavigate}>
        <img src={Logo} alt="GoodMove" className="sidebar-brand__logo" />
      </Link>

      <button
        type="button"
        className="sidebar-brand__close"
        onClick={onNavigate}
        aria-label="Close navigation"
      >
        <FiX aria-hidden="true" />
      </button>
    </div>

    <div className="sidebar-product">
      <span className="sidebar-product__pulse" />
      <span>
        <strong>Manager Console</strong>
        <small>Logistics operations</small>
      </span>
    </div>

    <div className="sidebar-scroll" data-simplebar>
      <SidebarContent onNavigate={onNavigate} condensed={type === "condensed"} />
    </div>

    <div className="sidebar-glow sidebar-glow--one" />
    <div className="sidebar-glow sidebar-glow--two" />
  </aside>
);

Sidebar.propTypes = {
  type: PropTypes.string,
  isOpen: PropTypes.bool,
  onNavigate: PropTypes.func,
};

Sidebar.defaultProps = {
  isOpen: false,
  onNavigate: () => {},
};

const mapStatetoProps = (state) => ({
  layout: state.Layout,
});

export default connect(mapStatetoProps, {})(withTranslation()(Sidebar));


// import PropTypes from "prop-types"
// import React from "react"
// import { connect } from "react-redux"
// // import { withRouter } from "react-router-dom"
// import Logo from '../../images/light_- horizontal.png';
// import logo1 from '../../images/light_- logotype.png';
// import logo2 from '../../images/light_- vertical.png'
// //i18n
// import { withTranslation } from "react-i18next"
// import SidebarContent from "./SidebarContent";
// import "../../styles/sidebar.css";

// import { Link } from "react-router-dom"

// import logo from "../../assets/images/logo.svg"
// import logoLightPng from "../../assets/images/logo-light.png"
// import logoLightSvg from "../../assets/images/logo-light.svg"
// import logoDark from "../../assets/images/logo-dark.png"

// const Sidebar = props => {

//   return (
//     <React.Fragment>
//       <div className="vertical-menu" style={{backgroundColor:"#ECECEC"}}>
//         <div className="navbar-brand-box">
//           <Link to="/" className="logo logo-dark">
//             <span className="logo-sm">
//               {/* <img src={logo} alt="" height="22"  /> */}
//             </span>
//             <span className="logo-lg">
//               {/* <img src={logoDark} alt="" height="17" /> */}
//             </span>
//           </Link>

//           <Link to="/" className="logo logo-light">
//             {/* <span className="logo-sm">
//               <img src={logoLightSvg} alt="" height="22" />
//             </span>
//             <span className="logo-lg">
//               <img src={logoLightPng} alt="" height="19" />
              
//             </span>
//             <span></span> */}
//             <div className="logoimg" style={{position:'relative',left:"-10px"}} >
//               <img src={Logo} style={{width:"200px",height:"55px"}}/>
//               {/* <img src={logo1} style={{width:"160px",height:"30px"}}/> */}
//               {/* <img src={logo2} style={{width:"200px",height:"150px"}}/> */}

//               </div>
//               {/* <span style={{color:"green",fontSize:"22px",textAlign:"left"}}>GOOD<b style={{color:"black"}}>MOVE</b></span></div> */}
//           </Link>
//         </div>
//         <div data-simplebar className="h-100">
//           {props.type !== "condensed" ? <SidebarContent  /> : <SidebarContent />}
//         </div>
//         <div className="sidebar-background"></div>
//       </div>
//     </React.Fragment>
//   )
// }

// Sidebar.propTypes = {
//   type: PropTypes.string,
// }

// const mapStatetoProps = state => {
//   return {
//     layout: state.Layout,
//   }
// }
// export default connect(
//   mapStatetoProps,
//   {}
// )(withTranslation()(Sidebar))
